import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({name: 'fields'})
export class fetchFieldsPipe implements PipeTransform {
    transform(value: any[]): any[] {
        let fetchedFields = []
        if(value.length>0){
            fetchedFields = [
                ...value.map(items => items.field)
            ]
        }
        return fetchedFields;
    }
}
